/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Admin_External_Booking_Edit_Show_More_InvoicesInputs */

const en_admin_external_booking_edit_show_more_invoices = /** @type {(inputs: Admin_External_Booking_Edit_Show_More_InvoicesInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural == "one") return /** @type {LocalizedString} */ (`Show 1 more`);
	if (countPlural == "other") return /** @type {LocalizedString} */ (`Show ${i?.count} more`);
	return /** @type {LocalizedString} */ ("admin.external_booking_edit.show_more_invoices");
};

const de_admin_external_booking_edit_show_more_invoices = /** @type {(inputs: Admin_External_Booking_Edit_Show_More_InvoicesInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("de", i?.count, {});
	if (countPlural == "one") return /** @type {LocalizedString} */ (`1 weitere anzeigen`);
	if (countPlural == "other") return /** @type {LocalizedString} */ (`${i?.count} weitere anzeigen`);
	return /** @type {LocalizedString} */ ("admin.external_booking_edit.show_more_invoices");
};

const es_admin_external_booking_edit_show_more_invoices = /** @type {(inputs: Admin_External_Booking_Edit_Show_More_InvoicesInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("es", i?.count, {});
	if (countPlural == "one") return /** @type {LocalizedString} */ (`Mostrar 1 más`);
	if (countPlural == "other") return /** @type {LocalizedString} */ (`Mostrar ${i?.count} más`);
	return /** @type {LocalizedString} */ ("admin.external_booking_edit.show_more_invoices");
};

const fr_admin_external_booking_edit_show_more_invoices = /** @type {(inputs: Admin_External_Booking_Edit_Show_More_InvoicesInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("fr", i?.count, {});
	if (countPlural == "one") return /** @type {LocalizedString} */ (`Afficher 1 de plus`);
	if (countPlural == "other") return /** @type {LocalizedString} */ (`Afficher ${i?.count} de plus`);
	return /** @type {LocalizedString} */ ("admin.external_booking_edit.show_more_invoices");
};

/** @type {(inputs: Admin_External_Booking_Edit_Show_More_InvoicesInputs) => LocalizedString} */
const it_admin_external_booking_edit_show_more_invoices = en_admin_external_booking_edit_show_more_invoices;

/** @type {(inputs: Admin_External_Booking_Edit_Show_More_InvoicesInputs) => LocalizedString} */
const pt_br2_admin_external_booking_edit_show_more_invoices = en_admin_external_booking_edit_show_more_invoices;

/** @type {(inputs: Admin_External_Booking_Edit_Show_More_InvoicesInputs) => LocalizedString} */
const pl_admin_external_booking_edit_show_more_invoices = en_admin_external_booking_edit_show_more_invoices;

/** @type {(inputs: Admin_External_Booking_Edit_Show_More_InvoicesInputs) => LocalizedString} */
const hu_admin_external_booking_edit_show_more_invoices = en_admin_external_booking_edit_show_more_invoices;

/** @type {(inputs: Admin_External_Booking_Edit_Show_More_InvoicesInputs) => LocalizedString} */
const ro_admin_external_booking_edit_show_more_invoices = en_admin_external_booking_edit_show_more_invoices;

/**
* | countPlural | output |
* | --- | --- |
* | "one" | "Show 1 more" |
* | "other" | "Show {count} more" |
*
* @param {Admin_External_Booking_Edit_Show_More_InvoicesInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_edit_show_more_invoices = /** @type {((inputs: Admin_External_Booking_Edit_Show_More_InvoicesInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_Edit_Show_More_InvoicesInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_edit_show_more_invoices(inputs)
	if (locale === "de") return de_admin_external_booking_edit_show_more_invoices(inputs)
	if (locale === "es") return es_admin_external_booking_edit_show_more_invoices(inputs)
	if (locale === "fr") return fr_admin_external_booking_edit_show_more_invoices(inputs)
	if (locale === "it") return it_admin_external_booking_edit_show_more_invoices(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_edit_show_more_invoices(inputs)
	if (locale === "pl") return pl_admin_external_booking_edit_show_more_invoices(inputs)
	if (locale === "hu") return hu_admin_external_booking_edit_show_more_invoices(inputs)
	return ro_admin_external_booking_edit_show_more_invoices(inputs)
});
export { admin_external_booking_edit_show_more_invoices as "admin.external_booking_edit.show_more_invoices" }